import React from 'react';
import Lottie from 'lottie-react';
import { Box } from '@mui/material';
import useLottieAnimation from 'src/hooks/useLottieAnimation';

const LottieSpinner = ({ size = 160, sx = {}, ...other }) => {
  const { animationData } = useLottieAnimation();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...sx,
      }}
      {...other}
    >
      {animationData ? (
        <Lottie
          animationData={animationData}
          style={{ height: size, width: size }}
          loop={true}
          autoplay={true}
        />
      ) : (
        <Box
          sx={{
            width: size,
            height: size,
            bgcolor: 'grey.200',
            borderRadius: '50%',
          }}
        />
      )}
    </Box>
  );
};

export default LottieSpinner;
